/* @flow */
// TODO: create breadcrubs helper , create generator
const getCrumb = (index, title, link) => {
	return {
		index,
		title,
		link,
	};
};
const getbreadcrumbsDefault = (citySlug) => [
	{
		index: 1,
		title: 'Главная',
		link: '/',
	},
	{
		index: 2,
		title: 'Статьи',
		link: `/${citySlug}/articles/`,
	},
];
export const generateBreadcrumbs = (citySlug: string, crumbs) => {
	const breadcrumbsDefault = getbreadcrumbsDefault(citySlug);

	if (citySlug && crumbs) {
		return [...breadcrumbsDefault, ...crumbs];
	}
	return [...breadcrumbsDefault];
};
